<app-page>
  <app-approval-delivery-feed [deliveryId]="deliveryId"></app-approval-delivery-feed>
</app-page>
